export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20221125_0503_CBYM1530_tn.b851d637.jpg";